import { DiskPerformanceTab } from "..";

export const DiskPerformanceScreenBody = (data: any) => {
  return (
    <>
      <DiskPerformanceTab data={data[0]} lineData={data[1]} />
    </>
  );
};
